export const SECONDARY_LEAVE_MESSAGES = [
  'I want an unsecured loan',
  'Need more/less money',
  'Want variable rate',
  'Don’t want a lump sum',
];

export const Reasons = {
  COMING_BACK: 'COMING_BACK',
  NOT_LOOKING_FOR: 'NOT_LOOKING_FOR',
  CONFUSED: 'CONFUSED',
  RATES_TOO_HIGH: 'RATES_TOO_HIGH',
  BETTER_OFFER: 'BETTER_OFFER',
  HIGHER_AMOUNT: 'HIGHER_AMOUNT',
  FOUND_BETTER_OFFER: 'FOUND_BETTER_OFFER',
  OTHER: 'OTHER',
};
